export default "__VITE_ASSET__113b745d__"